export default "__VITE_PUBLIC_ASSET__dde273db__"